import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmInvoiceVO {
  id?: number
  caseId: number
  customerId?: number
  receiptId?: number
  invoiceNo: string
  title?: string
  amount: number
  invoiceDate: string
  fileUrl?: string
  status?: string
  caseTitle?: string
  firmCaseNo?: string
  remark?: string
}

export interface FirmInvoicePageReq extends PageParam {
  caseId?: number
  status?: string
  invoiceNo?: string
}

export const FirmInvoiceApi = {
  create: (data: FirmInvoiceVO) => request.post({ url: '/lawyer/firm/invoice/create', data }),
  update: (data: FirmInvoiceVO) => request.put({ url: '/lawyer/firm/invoice/update', data }),
  delete: (id: number) => request.delete({ url: '/lawyer/firm/invoice/delete?id=' + id }),
  get: (id: number) => request.get({ url: '/lawyer/firm/invoice/get?id=' + id }),
  page: (params: FirmInvoicePageReq) =>
    request.get<PageResult<FirmInvoiceVO>>({ url: '/lawyer/firm/invoice/page', params }),
  issue: (id: number) => request.put({ url: '/lawyer/firm/invoice/issue?id=' + id }),
  void: (data: { id: number; voidReason?: string }) =>
    request.put({ url: '/lawyer/firm/invoice/void', data })
}
